var OrderWithdrawAddon = (function ($) {

    var FORM_SELECTOR = "#order-withdraw-form";
    var HEADER_LINK_SELECTOR = ".order-withdraw-link";
    var REOPEN_LINK_SELECTOR = ".order-withdraw-fallback-stay";

    function hideOverlaySpinner() {
        if (messageOverlay !== null) {
            messageOverlay.hide();
        }
    }

    function showOverlayError() {
        if (messageOverlay === null) {
            initOverlaySpinner("");
        }
        messageOverlay.showError("");
        messageOverlay.hideSlow();
    }

    function refreshPopupLayout() {
        if (!$.fancybox || !$.fancybox.current) {
            return;
        }

        $.fancybox.update();
        $.fancybox.reposition();
    }

    function watchCaptchaRender() {
        var captchaContainer = document.querySelector("#recaptcha_container");
        if (!captchaContainer || typeof MutationObserver === "undefined") {
            return;
        }

        var observer = new MutationObserver(function () {
            refreshPopupLayout();
        });

        observer.observe(captchaContainer, { childList: true, subtree: true, attributes: true });

        setTimeout(function () {
            observer.disconnect();
        }, 5000);
    }

    function openPopup(response) {
        $.fancybox({
            width: 500,
            height: "auto",
            autoHeight: true,
            content: response,
            fitToView: true,
            autoSize: false,
            afterShow: function () {
                bindFormSubmit();
                bindPopupLinks();
                refreshPopupLayout();
                watchCaptchaRender();
                setTimeout(refreshPopupLayout, 250);
                setTimeout(refreshPopupLayout, 1000);
                setTimeout(refreshPopupLayout, 2500);
            },
            helpers: {
                overlay: {
                    locked: true
                }
            }
        });
    }

    function normalizePayload(payload) {
        payload.forEach(function (item) {
            if (item.name === "rdNumber") {
                item.value = item.value.replace(/\D+/g, "");
            }
        });
    }

    function bindFormSubmit() {
        $(FORM_SELECTOR).off("submit.orderWithdraw").on("submit.orderWithdraw", function (event) {
            event.preventDefault();

            var token = $(this).find("input[name='_csrf']").val();
            var payload = $(this).serializeArray();
            normalizePayload(payload);

            initOverlaySpinner("");
            $.ajax({
                url: $(this).attr("action"),
                type: "POST",
                data: payload,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("X-CSRF-TOKEN", token);
                }
            }).done(function (response) {
                hideOverlaySpinner();
                handleFormResponse(response);
            }).fail(function () {
                showOverlayError();
            });
        });
    }

    function handleFormResponse(response) {
        var responsePage = $($.parseHTML(response));
        var errorContainer = responsePage.find("#order-withdraw-error-container");
        var captchaErrorMessageContainer = responsePage.find(".captcha-error-message-container").first();

        openPopup(response);

        if (errorContainer.length || captchaErrorMessageContainer.length) {
            showOverlayError();
        }
    }

    function bindPopupLinks() {
        $(REOPEN_LINK_SELECTOR).off("click.orderWithdraw").on("click.orderWithdraw", function (event) {
            event.preventDefault();
            loadPopup($(this).attr("href"));
        });
    }

    function loadPopup(url) {
        $.ajax({
            url: url,
            type: "GET",
            cache: false
        }).done(function (response) {
            openPopup(response);
        }).fail(function () {
            showOverlayError();
        });
    }

    function initialize() {
        $(HEADER_LINK_SELECTOR).off("click.orderWithdraw").on("click.orderWithdraw", function (event) {
            event.preventDefault();
            loadPopup($(this).attr("href"));
        });
    }

    return {
        initialize: initialize
    };

})($);

$(function () {
    OrderWithdrawAddon.initialize();
});
